export class SemVer {
  major: number;
  minor: number;
  patch?: number;

  constructor(major: number, minor: number, patch?: number) {
    this.major = major;
    this.minor = minor;
    this.patch = patch;
  }

  toJSON(): unknown {
    return this.toString();
  }

  toString(): string {
    if (this.patch === undefined) {
      return `${this.major}.${this.minor}`;
    } else {
      return `${this.major}.${this.minor}.${this.patch}`;
    }
  }
}
